import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {ta_startFetchDetail} from '../../actions';
import {allWords, titleCase} from '../../lib/urlTools';
import styles from './sta.scss';
import formStyles from '../Forms/FormPanel.scss';
import PropTypes from 'prop-types';
import {escapeSymbols} from '../../lib/formatting';

class SuburbTypeahead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVis: false,
      activeItem: 0,
      userInput: '',
    };
    this.classes = styles.sbtaSearch;
    if (this.props.hasOwnProperty('size')) this.classes = this.classes + ' ' + styles[this.props.size];
    if (this.props.hasOwnProperty('bias')) this.classes = this.classes + ' ' + styles[this.props.bias];
    this.destination = 'suburbResearch';
    if (this.props.hasOwnProperty('destination')) this.destination = this.props.destination;
    this.placeholder = 'Search for a Suburb';
    if (this.props.hasOwnProperty('placeholder')) this.placeholder = this.props.placeholder;
    this.linkExternal = false;
    if (this.props.hasOwnProperty('linkExternal')) this.linkExternal = this.props.linkExternal;
  }
  componentDidUpdate = (prevProps) => {
    if (prevProps.destination != this.props.destination) {
      this.destination = this.props.destination
    }
  }
  onChange = e => {
    this.setState({userInput: e.target.value});
    if (e.target.value != '') {
      this.props.ta_startFetchDetail(e.target.value);
      this.searchVis(true);
    }
    else this.searchVis(false);
  }

  onBlur = () => {
    this.setState({
      searchVis: false,
    });
  }

  onFocus = () => {
    if (this.state.userInput != '' && this.props.suburbBanner.suburb_list.content.length) {
      this.setState({
        searchVis: true,
      });
    }
  }

  keyDown = (e) => {
    const {activeItem} = this.state;
    if (e.keyCode === 38) { // up
      if (activeItem > 0) this.setState({activeItem: activeItem - 1});
      else this.setState({activeItem: this.props.suburbBanner.suburb_list.content.length - 1});
    }
    else if (e.keyCode === 40) { // down
      if (activeItem < this.props.suburbBanner.suburb_list.content.length-1) this.setState({activeItem: activeItem + 1});
      else if (activeItem == this.props.suburbBanner.suburb_list.content.length-1) this.setState({activeItem: 0});
    }
    else if (e.keyCode === 9) { // tab
      if (e.target.value != '') this.gotToSuburb();
    }
  }

  keyUp = (e) => {
    if (e.keyCode === 13) { // enter or tab
      if (e.target.value != '') this.gotToSuburb();
    }
    else if (e.keyCode === 27) { // escape
      this.setState({
        activeItem: 0,
        userInput: '',
        searchVis: false,
      });
    }
    else {
      if (e.target.value == '') this.props.suburbBanner.suburb_list.content = [];
    }
  }

  searchVis = (vis) => {
    this.setState({searchVis: vis});
  }

  setActiveIndex = (indx) => {
    this.setState({activeItem: indx});
  }

  getSuburbURL = (sub) => {
    // "/stateCode/suburb-postCode"
    let suburbURL = sub.stateCode + '/';
    suburbURL = suburbURL + sub.suburb.replace(/-/ig, '--').replace(/\s/ig, '-') + '-';
    suburbURL = suburbURL + sub.postCode;
    return suburbURL.toLowerCase();
}

  gotToSuburb = () => {
    let sub = this.props.suburbBanner.suburb_list.content[this.state.activeItem];
    if (sub) {
      this.setState({userInput:'', searchVis:false});
      this.props.suburbBanner.suburb_list.content = [];

      let newurl = '/';
      switch (this.destination) {
        case 'agents':
          newurl = '/real-estate-agents/' + this.getSuburbURL(sub);
          break;
        case 'agencies':
          newurl = '/real-estate-agencies/' + this.getSuburbURL(sub);
          break;
        case 'function':
          // requires the returnFunction prop
          if (this.props.returnFunction) {
            this.props.returnFunction(sub);
            return;
          }
          break;
        default:
          newurl = '/suburb/' + this.getSuburbURL(sub);
          break;
      }

      // @todo this is the temporary external link to result,
      // we should remove this after migration finished.
      if (this.linkExternal) {
        window.location = newurl;
      }
      else {
        this.props.history.push(newurl, {suburb: sub.suburb, state: sub.stateCode, postcode: sub.postCode});
      }
    }
  }

  formatResult = (addressData) => {
    // format the address into titlecase and bolded keyword match
    const re = new RegExp(escapeSymbols(this.state.userInput), 'ig');
    let prettysuburb = addressData.suburb.replace(allWords, titleCase);
    let fa = prettysuburb + ', ' + addressData.stateCode + ', ' + addressData.postCode;
    return {__html: fa.replace(re, '<strong>$&</strong>')};
  }

  render() {
    const suburbBanner = this.props.suburbBanner;
    return (
      <div className={this.classes}>
        <div className="input-group">
          <input type="text"
            className={`form-control flex-grow-1 w-auto ${styles.magnifier}`}
            placeholder={this.placeholder}
            onKeyUp={this.keyUp}
            onKeyDown={this.keyDown}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            value={this.state.userInput}
            aria-label="Enter Suburb" />
            {this.props.size && this.props.size == 'marketWatch' && !this.props.isTrackedSuburbPage ? <button className="ml-2 pl-4 pr-4 odinButton inline">Search</button> : null}
        </div>
        { suburbBanner.suburb_list.content.length ?
          <ul className={this.state.searchVis ? styles.show : styles.hide}>{
            suburbBanner.suburb_list.content.map((suburb_item, index) => (
              <li
                className={this.state.activeItem == index ? styles.active : ''}
                onMouseOver={() => this.setActiveIndex(index) }
                onMouseDown={this.gotToSuburb}
                key={index}
                dangerouslySetInnerHTML={this.formatResult(suburb_item)}>
              </li>
            ))
          }</ul>
          : null
        }
      </div>
    );
  }
}

SuburbTypeahead.propTypes = {
  suburbBanner: PropTypes.object.isRequired,
  history: PropTypes.object,
  ta_startFetchDetail: PropTypes.func.isRequired,
  size: PropTypes.string,
  destination: PropTypes.string,
  placeholder: PropTypes.string,
  linkExternal: PropTypes.bool,
  returnFunction: PropTypes.func,
  isTrackedSuburbPage: PropTypes.bool
};

const mapStateToProps = (state) => ({ suburbBanner: state.suburbTypeahead});
const mapDispatchToProps = { ta_startFetchDetail };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuburbTypeahead));
